import { useMemo } from "react";
import { Modal } from "@repo/ui";
import { useTheme } from "@repo/tokens";

interface TestModalProps {
  isOpen: boolean;
  onClose: () => void;
  body: React.ReactNode;
  width?: number | string;
  dismissable?: boolean;
  isOverlay?: boolean;
}

export const TestModal = ({
  isOpen,
  onClose,
  body,
  width = 640,
  dismissable = true,
  isOverlay = false,
}: TestModalProps) => {
  const { theme } = useTheme();

  const modalStyles = useMemo(() => {
    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
    const isDrawer = isMobile && !isOverlay;
    const topRadius = isDrawer ? 40 : theme.radii["2xl"];
    return {
      modal: {
        borderTopLeftRadius: topRadius,
        borderTopRightRadius: topRadius,
        borderBottomLeftRadius: isDrawer ? 0 : theme.radii["2xl"],
        borderBottomRightRadius: isDrawer ? 0 : theme.radii["2xl"],
        ...(isDrawer
          ? { maxHeight: "100dvh", width: "100%", maxWidth: "100%" }
          : {
              boxShadow: "0 1px 100px rgba(0, 0, 0, 0.32)",
            }),
      },
      body: {
        overflowY: "auto" as const,
        WebkitOverflowScrolling: "touch" as const,
      },
    };
  }, [theme, isOverlay]);

  return (
    <Modal
      isModalOpen={isOpen}
      onClose={dismissable ? onClose : () => {}}
      showHeader={false}
      showFooter={false}
      width={width}
      height="auto"
      styles={modalStyles}
      body={body}
      alignItems={isOverlay ? "center" : undefined}
      justifyContent={isOverlay ? "center" : undefined}
    />
  );
};
